var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3268_55157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 26C19 27.1 18.1 28 17 28C15.9 28 15 27.1 15 26C15 24.9 15.9 24 17 24C18.1 24 19 24.9 19 26ZM17 18C15.9 18 15 18.9 15 20C15 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18ZM17 12C15.9 12 15 12.9 15 14C15 15.1 15.9 16 17 16C18.1 16 19 15.1 19 14C19 12.9 18.1 12 17 12ZM23 16C24.1 16 25 15.1 25 14C25 12.9 24.1 12 23 12C21.9 12 21 12.9 21 14C21 15.1 21.9 16 23 16ZM23 18C21.9 18 21 18.9 21 20C21 21.1 21.9 22 23 22C24.1 22 25 21.1 25 20C25 18.9 24.1 18 23 18ZM23 24C21.9 24 21 24.9 21 26C21 27.1 21.9 28 23 28C24.1 28 25 27.1 25 26C25 24.9 24.1 24 23 24Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3268_55157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/threeDots.7d125510c441312578671be8689e6dc5.svg";
export { ForwardRef as ReactComponent };